/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["#actions[_ngcontent-%COMP%]   button.btn-danger-outline[_ngcontent-%COMP%], #actions[_ngcontent-%COMP%]   button.btn-outline[_ngcontent-%COMP%]{float:right}"];
export { styles as styles };

